/**
 * Moduł obsługujący nowe główne menu strukturalnie współdzielone z headless
 * @type {module}
 */
app.service('headlessMenu',function(focusTrap) {
	let isInit = false, isMenuOpen = false, isSubcategoryOpen = false;
	let $self;
	let $mainCategoryItem, $subcategoryItem, $menuStaticLinks;
	// cache elementow DOM
	function setElements() {
		$self = $('#headless-main-menu');
		$mainCategoryItem = $('.nav-main-category-item', $self);
		$subcategoryItem = $('.nav-subcategory-item', $self);
		$menuStaticLinks = $('#menu-static-links', $self);
	}

	function setEvents(){
		// obsługa przycisku rozwijającego submenu kategorii głównej
		$('.nav-main-category-expand-btn', $self).on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			openCategory($(this).closest('.nav-main-category-item'));
			UA.push({
				event: "navigation_category_click",
				clicked_text: $(this).data('category-name'),
				clicked_url: $(this).data('category-url')
			});
		}).on('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				e.stopPropagation();
				openCategory($(this).closest('.nav-main-category-item'));
			}
		});

		// obsługa dla subcategory items bez linków
		$('.nav-subcategory-item:not(:has(> a.nav-category-link))', $self).on('click', function (e) {
			openCategory($(this));
		}).on('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				e.stopPropagation();
				openCategory($(e.target).parent());
			}
		});

		$('.js-back-to-main-menu', $self).on('click', function(e) {
			resetAllOpenCategories();
		}).on('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				e.stopPropagation();
				resetAllOpenCategories();
			}
		});

		$('.js-back-to-category', $self).on('click', function(e) {
			closeSubcategory();
		}).on('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				e.stopPropagation();
				closeSubcategory();
			}
		});

		// sticky header
		$('.nav-main-category-content, .nav-subcategory-content', $self).each(function() {
			setStickyHeaderEvent($(this));
		});
		setStickyHeaderEvent($('#headless-mobile-menu-modal #headless-mobile-menu'));

		$('body').on('keydown', function(e) {
			if (e.key === 'Escape' && isMenuOpen) { // zablokowanie domyślnego zamykania modala z menu
				e.preventDefault();
				e.stopPropagation();
			}
		}).on('keyup', function(e) {
			if (e.key === 'Escape' && isMenuOpen) { // obsługa klawisza Escape dla menu głównego
				e.preventDefault();
				e.stopPropagation();
				closeActiveMenuLayer();
			}
		});

		$menuStaticLinks.on('click', '.js-static-menu-item-link', function() {
			UA.push({
				event: "navigation_static_link_click",
				clicked_text: $(this).find('.static-menu-item-text').text(),
				clicked_url: $(this).attr('href')
			});
		});
	}

	function openCategory($categoryItem) {
		if ($categoryItem.hasClass('nav-main-category-item')) {
			isMenuOpen = true;
			$categoryItem.find('.nav-main-category-expand-btn').attr('aria-expanded', 'true');
		} else if ($categoryItem.hasClass('nav-subcategory-item')) {
			isSubcategoryOpen = true;
			$categoryItem.children().eq(0).attr('aria-expanded', 'true');
		}
		$categoryItem.parent().addClass('active').siblings().removeClass('active');
		$categoryItem.next().focus();
		focusTrap.set($categoryItem.next());
	}
	function closeSubcategory() {
		isSubcategoryOpen = false;
		focusTrap.reset($('.nav-subcategory.active .focustrapped'));
		$('.nav-subcategory.active > .nav-subcategory-item .nav-subcategory-item-focus', $self).attr('aria-expanded', 'false').focus();
		$('.nav-subcategory.active', $self).removeClass('active');
	}
	function closeActiveMenuLayer() {
		if (isSubcategoryOpen) {
			closeSubcategory();
		} else if (isMenuOpen) {
			// reset aktywnych kategorii
			resetAllOpenCategories();
		}
	}
	function resetAllOpenCategories() {
		isMenuOpen = false;
		isSubcategoryOpen = false;
		focusTrap.reset($('#headless-main-menu .focustrapped'));
		const $activeMainCategory = $('.nav-main-category-list-item.active', $self);
		$activeMainCategory.find('.nav-main-category-expand-btn').attr('aria-expanded', 'false');
		$self.find('.active').removeClass('active'); // reset wszystkich aktywnych kategorii
		$activeMainCategory.find('.nav-main-category-expand-btn').focus();
	}

	function setStickyHeader(scrollPosition, $container, stickyHeaderSelector = '.stickable-header') {
		const $containerStickyHeader = $container.find(stickyHeaderSelector).first();
		const containerStickyHeaderHeight = $containerStickyHeader.height();
		if(scrollPosition > containerStickyHeaderHeight) {
			$containerStickyHeader.addClass('sticky-menu-header');
		} else {
			$containerStickyHeader.removeClass('sticky-menu-header');
		}
	}
	function setStickyHeaderEvent($container, stickyHeaderSelector) {
		let ticking = false;
		$container.on('scroll',function(){
			const containerHeight = $container.scrollTop();
			if (!ticking) {
				requestAnimationFrame(function(e){
					setStickyHeader(containerHeight, $container, stickyHeaderSelector);
					ticking = false;
				});
			}
			ticking = true;
		});
	}

	function init() {
		setElements();
		if (!isInit) {
			isInit = true;
			setEvents();
		}
	}

	return {
		init,
		reset: resetAllOpenCategories
	};
});
